import { motion } from "framer-motion";
import { Gauge } from "lucide-react";
import SceneShell from "../components/SceneShell";

/**
 * Scene 59 — Not just evolving · accelerating.
 */

export default function Scene59_Accelerating() {
  return (
    <SceneShell variant="ink" align="center" data-testid="scene-accelerating">
      <motion.div
        className="absolute inset-0 pointer-events-none"
        animate={{
          background: [
            "radial-gradient(ellipse at center, rgba(233,168,32,0.16) 0%, transparent 55%)",
            "radial-gradient(ellipse at center, rgba(233,168,32,0.32) 0%, transparent 55%)",
            "radial-gradient(ellipse at center, rgba(233,168,32,0.16) 0%, transparent 55%)",
          ],
        }}
        transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
      />

      {/* Speed lines */}
      {[0, 1, 2, 3, 4].map((i) => (
        <motion.span
          key={i}
          className="absolute pointer-events-none"
          style={{
            left: -120,
            top: `${20 + i * 14}%`,
            width: 220,
            height: 2,
            background:
              "linear-gradient(90deg, transparent 0%, rgba(233,168,32,0.55) 50%, transparent 100%)",
          }}
          animate={{ x: ["0%", "750%"] }}
          transition={{
            duration: 2.4,
            repeat: Infinity,
            delay: i * 0.4,
            ease: "linear",
          }}
        />
      ))}

      <div className="relative max-w-[1500px] mx-auto w-full text-center">
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="kn-eyebrow mx-auto flex items-center justify-center gap-2"
        >
          <Gauge className="w-3.5 h-3.5" style={{ color: "#e9a820" }} />
          The future vision · accelerating
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.3 }}
          className="mt-10 text-2xl sm:text-3xl lg:text-4xl"
          style={{ color: "rgba(255,255,255,0.78)" }}
        >
          We're in an{" "}
          <span style={{ color: "#e9a820", fontWeight: 700 }}>
            incredibly fast-moving space
          </span>
          .
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 1.4 }}
          className="mt-8 inline-block"
        >
          <span
            className="text-xl sm:text-2xl line-through"
            style={{
              color: "rgba(255,255,255,0.45)",
              textDecorationColor: "rgba(233,168,32,0.85)",
              textDecorationThickness: "2px",
            }}
          >
            It's not just evolving…
          </span>
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, scale: 0.85, filter: "blur(20px)" }}
          animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
          transition={{ duration: 1.2, delay: 2.0, ease: [0.16, 1, 0.3, 1] }}
          className="mt-6 kn-display leading-[1.1] pb-2"
          style={{
            fontSize: "clamp(56px, 8.5vw, 130px)",
            background:
              "linear-gradient(135deg, #d4940a 0%, #e9a820 50%, #d4940a 100%)",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            color: "transparent",
            textShadow: "0 0 80px rgba(233,168,32,0.45)",
            fontWeight: 900,
          }}
          data-testid="accelerating-headline"
        >
          It's accelerating.
        </motion.h2>
      </div>
    </SceneShell>
  );
}
